export enum InvoiceSecondaryStatus {
  RECEIVED_FOR_PROCESSING = 'received_for_processing',
  DELAYED = 'delayed',
  FAILED_INVALID_CONTENT = 'failed_invalid_content',
  FAILED = 'failed',
  FAILED_REJECTED = 'failed_rejected',
  DELIVERED = 'delivered',
}
